export const headingAbout = () => {
  const elements = document.querySelectorAll(".c-heading-about");
  if (!elements.length) return;

  gsap.registerPlugin(ScrollTrigger);

  elements.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 75%",
      once: false,
      onEnter: () => setTimeout(() => el.classList.add("is-active"), 300),
    });
  });
};
